import { Observable } from 'rxjs';
import { BlocEvent } from 'src/app/shared/bloc/base-bloc';

import { ConfirmationModalActions } from '../../common';

export type ConfirmationCallerCallBack<Data> = (reason?: ConfirmationModalActions) => Observable<Data>;
export abstract class ConfirmationEvent extends BlocEvent {}

export class ConfirmationSubmitEvent<T, Data> extends ConfirmationEvent {
  constructor(public caller: ConfirmationCallerCallBack<Data>, public action: ConfirmationModalActions) {
    super();
  }
}
